// Vaccines that must be booked on their own and cannot be combined with any other vaccine
export const exclusiveVaccines = ['yellow fever'];

export const isExclusiveVaccine = (label) => exclusiveVaccines.includes(label);
